var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{staticClass:"mt-0",attrs:{"rules":_vm.rules,"label":_vm.label,"value":_vm.value,"readonly":_vm.readonly,"required":_vm.required},on:{"change":_vm.sendToParent},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }